export enum EXPERT_PROFILE_TABS {
  PROFILE = "profile",
  PROJECTS = "projects",
  SURVEYS = "surveys",
  INTERNAL_COMMENTS = "internalComments",
  SCREENING = "screening",
  PROJECT_NOTES = "projectNotes",
  PAYMENTS = "payments"
}
